'use client';

import React from 'react';
import { AccordionProvider } from './AccordionContext';

export interface AccordionProps {
	allowMultiple?: boolean;
	onToggle?: (toggledId: string, status: 'closed' | 'opened') => void;
	children: React.ReactNode;
}
const Accordion = (props: AccordionProps) => {
	const { allowMultiple, onToggle, children } = props;

	return (
		<AccordionProvider onToggle={onToggle} allowMultiple={allowMultiple}>
			<ul>{children}</ul>
		</AccordionProvider>
	);
};

export default Accordion;
